import React from 'react'
import Agency from '../Components/Agency';
import Banner from '../Components/Banner';
import Creative from '../Components/Creative';
import Features from '../Components/Features';
import Video from '../Components/Video';
// import Webdev from '../Components/Webdev';
import Choose from  "../Components/Choose"
import Project from '../Components/Project';
import Clients from 'src/Components/Clients';
import Blog from 'src/Components/Blog';

const Homepage = () => {
  return (
    <div>
      <Banner/>
      <Features />
      <Creative/>
      <Agency/>
      {/* <Webdev/> */}
      <Video/>
      <Choose/>
      <Project/>
      <Clients/>
      <Blog/>
    </div>
  )
}

export default Homepage